export default "__VITE_ASSET__MfYVooT5__"